import React from 'react';
import { EmployeeManagementCard } from './EmployeeManagementCard';

export const EmployeeManagementPage: React.FC = () => {
  return (
    <div style={{ maxWidth: 1000, margin: '0 auto', padding: 24 }}>
      <EmployeeManagementCard />
    </div>
  );
};
